import React, { useEffect, useState } from "react";
import { invokeApi } from "../../../helper/axiosHelper";

/* The floating member-count chip on the vendor auth illustration.
 *
 * Shared by login, forgot and reset so the three screens can never show
 * different numbers - they are the same picture. */
export default function VendorAuthChips() {
    return null;

    // stop calling api 
    // const [members, setMembers] = useState(null);

    // useEffect(() => {
    //     /* nobody is signed in on these screens, so this reads the public
    //        /portalStats - see vendor_portal/app/portal-stats */
    //     let cancelled = false;

    //     invokeApi("get", "/portalStats", null, null, "vendor").then((response) => {
    //         if (cancelled || !response?.status) {
    //             return;
    //         }
    //         const count = Number(response?.data?.members);
    //         setMembers(Number.isFinite(count) ? count : null);
    //     });

    //     return () => {
    //         cancelled = true;
    //     };
    // }, []);

    // /* held back until the real count is in - a placeholder number here would
    //    read as a fact about the portal */
    // if (members === null) {
    //     return null;
    // }

    // return (
    //     <div className="va-chip va-chip-a">
    //         <span className="va-ic">👥</span>
    //         {members.toLocaleString()} members
    //     </div>
    // );
}
